// @ts-nocheck

/**
 * Map of forecast types to their available variations
 * Each variation has a display name and a key used for data lookups
 */
export const FORECAST_VARIATIONS = {
  'precipitation': [
    { name: 'Hourly', key: 'Hourly' },
    { name: 'Cumulative', key: 'Cumulative' }
  ],
  'wind': [
    { name: 'Speed', key: 'Speed' },
    { name: 'Direction', key: 'Direction' }
  ],
  'wind80m': [
    { name: 'Speed', key: 'Speed' },
    { name: 'Direction', key: 'Direction' }
  ],
  'temperature': [
    { name: 'Hourly', key: 'Hourly' }
  ],
  'humidity': [
    { name: 'Hourly', key: 'Hourly' }
  ],
  'solar': [
    { name: 'Short Wave', key: 'sWave' },
    { name: 'Long Wave', key: 'lWave' }
  ],
  // HRRR models
  'hrrr-precipitation': [
    { name: 'Hourly', key: 'Hourly' },
    { name: 'Cumulative', key: 'Cumulative' }
  ],
  'hrrr-wind': [
    { name: 'Speed', key: 'Speed' },
    { name: 'Direction', key: 'Direction' }
  ],
  'hrrr-wind80m': [
    { name: 'Speed', key: 'Speed' },
    { name: 'Direction', key: 'Direction' }
  ],
  'hrrr-temperature': [
    { name: 'Hourly', key: 'Hourly' }
  ],
  'hrrr-humidity': [
    { name: 'Hourly', key: 'Hourly' }
  ],
  'hrrr-solar': [
    { name: 'Short Wave', key: 'sWave' },
    { name: 'Long Wave', key: 'lWave' }
  ]
};

export const PRECIPITATION_CHANNEL_OPTIONS = [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'precip' },
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'precip' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'precip' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'precip' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'precip' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'precip' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'precip' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'precip' }
        ];

export const HUMIDITY_CHANNEL_OPTIONS = [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'humidity' },
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'humidity' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'humidity' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'humidity' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'humidity' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'humidity' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'humidity' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'humidity' }
        ]

export const WIND_80_CHANNEL_OPTIONS = [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'wind80m' },
          { value: 'gefs50-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'wind80m' },
          { value: 'gefs50-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'wind80m' },
          { value: 'gefs50-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'wind80m' },
          { value: 'gefs50-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'wind80m' },
          { value: 'gefs50-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'wind80m' },
          { value: 'gefs50-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'wind80m' },
          { value: 'gefs50-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'wind80m' }
        ];

export const WIND_10_CHANNEL_OPTIONS = [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'wind10m' },
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'wind10m' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'wind10m' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'wind10m' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'wind10m' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'wind10m' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'wind10m' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'wind10m' }
        ];

export const TEMPERATURE_CHANNEL_OPTIONS = [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'temp' },
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'temp' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'temp' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'temp' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'temp' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'temp' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'temp' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'temp' }
        ];

export const SOLAR_SHORT_CHANNEL_OPTIONS =  [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'solarS' },
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'solarS' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'solarS' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'solarS' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'solarS' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'solarS' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'solarS' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'solarS' }
        ];

export const SOLAR_LONG_CHANNEL_OPTIONS =  [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'solarL' },
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'solarL' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'solarL' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'solarL' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'solarL' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'solarL' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'solarL' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'solarL' }
        ];

export const SNOW_WATER_CHANNEL_OPTIONS =  [
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'snowWater' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'snowWater' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'snowWater' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'snowWater' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'snowWater' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'snowWater' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'snowWater' }
        ];

export const SOIL_MOISTURE_CHANNEL_OPTIONS =  [
          { value: 'gefs25-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'soilMoisture' },
          { value: 'gefs25-average', label: 'Average (GEFS)', source: 'GEFS', dataType: 'soilMoisture' },
          { value: 'gefs25-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'soilMoisture' },
          { value: 'gefs25-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'soilMoisture' },
          { value: 'gefs25-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'soilMoisture' },
          { value: 'gefs25-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'soilMoisture' },
          { value: 'gefs25-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'soilMoisture' }
        ];

export const WIND_POWER_CHANNEL_OPTIONS = [
          { value: 'hrrr-Hourly', label: 'Hourly (HRRR)', source: 'HRRR', dataType: 'windPower' },
          { value: 'gefs50-control', label: 'Control (GEFS)', source: 'GEFS', dataType: 'windPower' },
          { value: 'gefs50-mean', label: 'Average (GEFS)', source: 'GEFS', dataType: 'windPower' },
          { value: 'gefs50-p10', label: '10th Percentile (GEFS)', source: 'GEFS', dataType: 'windPower' },
          { value: 'gefs50-p30', label: '30th Percentile (GEFS)', source: 'GEFS', dataType: 'windPower' },
          { value: 'gefs50-p50', label: '50th Percentile (GEFS)', source: 'GEFS', dataType: 'windPower' },
          { value: 'gefs50-p70', label: '70th Percentile (GEFS)', source: 'GEFS', dataType: 'windPower' },
          { value: 'gefs50-p90', label: '90th Percentile (GEFS)', source: 'GEFS', dataType: 'windPower' }
        ];